import { createFileRoute } from '@tanstack/react-router';
import { ReportsPage } from '@/features/payroll/reports/reports-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/payroll_/reports')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/payroll/reports');
  },
  component: ReportsPage,
});
